import { inject, Injectable } from '@angular/core';
import { UserStore } from './user/user.store';
import { ELoadingEntity, IErrorProperty } from 'src/models/generic-store.model';

@Injectable({ providedIn: 'root' })
export class UserDataService {
  private userStore = inject(UserStore);

  // State signals
  public loggedUser = this.userStore.loggedUser;
  public userLoadingProps = this.userStore.loadingProps;
  public isIdle = this.userStore.isIdle;
  public lastActive = this.userStore.lastActive;
  public contractsStats = this.userStore.contractsStats;
  public maxRiskScore = this.userStore.maxRiskScore;
  public userInstrumentCategories = this.userStore.userInstrumentCategories;
  public investmentProfile = this.userStore.investmentProfile;
  public userManagementType = this.userStore.userManagementType;
  public appearanceMode = this.userStore.appearanceMode;
  public isDarkMode = this.userStore.isDarkMode;

  public userIsLoading(loadingEntity: ELoadingEntity): boolean {
    return this.userStore.isLoading(loadingEntity);
  }

  public userHasErrored(loadingEntity: ELoadingEntity): boolean {
    return this.userStore.hasErrored(loadingEntity);
  }

  public userGetError(loadingEntity: ELoadingEntity): IErrorProperty | null {
    return this.userStore.getError(loadingEntity);
  }

  // Computed signals
  public userCurrencyCode = this.userStore.userCurrencyCode;
  public firstNameVocative = this.userStore.firstNameVocative;
  public aiAnalysisAllowed = this.userStore.aiAnalysisAllowed;

  public getCurrentUser(): void {
    this.userStore.getCurrentUser();
  }

  public getInvestmentProfile(): void {
    if (!this.loggedUser()) {
      console.warn('Cannot get investment profile: loggedUser is not loaded');
      return;
    }

    this.userStore.getInvestmentProfile({ clientId: this.loggedUser()!.clientAccountId });
  }

  public resetLoggedUser(): void {
    this.userStore.resetLoggedUser();
  }

  public resetUserState(): void {
    this.userStore.resetState();
  }

  public setIsIdle(isIdle: boolean): void {
    this.userStore.setIsIdle(isIdle);
  }

  public setLastActive(lastActive: string | null): void {
    this.userStore.setLastActive(lastActive);
  }

}
